import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import {
  createNotification,
  updateNotification,
} from "../../services/notification";
import AppLoader from "../../components/loader/loader";

const NotificationAdd = ({
  open,
  onClose,
  formData,
  setFormData,
  editData,
  fetchNotifications,
  selectedButton,
}) => {
  const [loading, setLoading] = useState(false);
  const snackRef = useRef();

  useEffect(() => {
    if (editData) {
      setFormData({
        title: editData.title,
        body: editData.body,
        type: editData.appType || selectedButton?.type,
      });
    } else {
      setFormData({
        title: "",
        body: "",
        type: selectedButton?.type || "customer",
      });
    }
  }, [editData, setFormData, selectedButton]);

  const handleOpenSnack = (status, message) => {
    if (snackRef.current) {
      snackRef.current.isOpenSnack({
        snackType: status,
        snackMessage: message,
      });
    }
  };
  const handleSubmit = async () => {
    if (!formData.title || !formData.body) {
      handleOpenSnack("error", "Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        title: formData.title,
        body: formData.body,
        appType: formData.type, // Always send appType
      };

      const response = editData?._id
        ? await updateNotification(editData._id, payload)
        : await createNotification(payload);

      if (response.status === 200 || response.status === 201) {
        handleOpenSnack("success", response.data.message);
        onClose(true);
        fetchNotifications(formData.type);
      } else {
        handleOpenSnack("error", response.data.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      handleOpenSnack("error", "An error occurred while saving");
    } finally {
      setLoading(false);
    }
  };

  const dialogStyles = {
    dialog: {
      borderRadius: "8px",
      minWidth: "400px",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      padding: "20px",
      border: "1px solid #e0e0e0",
      transition: "all 0.3s ease-in-out",
    },

    cancelButton: {
      backgroundColor: "red",
      color: "#fff",
      fontWeight: "bold",
      width: "100px",
    },
    submitButton: {
      backgroundColor: "primary.main",
      color: "#fff",
      fontWeight: "bold",
      width: "100px",
      marginLeft: "10px",
    },
  };
  return (
    <Dialog open={open} onClose={onClose} sx={dialogStyles.dialog}>
      <AppLoader isVisible={loading} />
      <DialogTitle>
        {editData ? "Edit Notification" : "Add Notification"}
      </DialogTitle>
      <DialogContent>
        <Select
          value={formData.type}
          onChange={(e) => setFormData({ ...formData, type: e.target.value })}
          disabled={!!editData}
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 1,
            marginTop: 2,
            marginBottom: 1,
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#800000",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#800000",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#800000",
            },
          }}
        >
          <MenuItem value="hire">Customer</MenuItem>
          <MenuItem value="worker">Provider</MenuItem>
        </Select>
        <TextField
          autoFocus
          margin="dense"
          label="Title"
          type="text"
          fullWidth
          value={formData.title}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          required
        />
        <TextField
          margin="dense"
          label="Body"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={formData.body}
          onChange={(e) => setFormData({ ...formData, body: e.target.value })}
          required
        />
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "right" }}>
        <Button onClick={onClose} sx={dialogStyles.cancelButton}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} sx={dialogStyles.submitButton}>
          {editData ? "Update" : "Add"}
        </Button>
      </DialogActions>
      <CustomSnackbar ref={snackRef} />
    </Dialog>
  );
};

export default NotificationAdd;
